import { Enum, EnumType } from 'ts-jenum';
import _ from 'lodash';
import { IGridFilterItem } from './filters/IGridFilterItem';
import { UserStatusEnum } from '../samwin/UserStatusEnum';
import { faHandsHelping, faPhone, faUsersCrown, IconDefinition } from '@fortawesome/pro-duotone-svg-icons';
import { faCircle as faDonut } from '@fortawesome/pro-regular-svg-icons/faCircle';
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';

@Enum<AgentListFilter>('value')
export class AgentListFilter extends EnumType<AgentListFilter>() implements IGridFilterItem {
   static readonly GREEN = new AgentListFilter(
      'GREEN',
      1,
      'brick.brick_definitions.agent_list.filter.itemName.signed_in_ready',
      faCircle,
      1,
      'user-status-ready'
   );
   static readonly YELLOW = new AgentListFilter(
      'YELLOW',
      2,
      'brick.brick_definitions.agent_list.filter.itemName.signed_in_not_ready',
      faCircle,
      1,
      'user-status-not-ready'
   );
   static readonly RED = new AgentListFilter(
      'RED',
      UserStatusEnum.BUSY.value,
      'brick.brick_definitions.agent_list.filter.itemName.signed_in_busy',
      faCircle,
      1,
      'user-status-busy'
   );
   static readonly GRAY = new AgentListFilter(
      'GRAY',
      3,
      'brick.brick_definitions.agent_list.filter.itemName.signed_in_logged_off',
      faCircle,
      1,
      'user-status-logged-off'
   );
   static readonly OFFLINE = new AgentListFilter('OFFLINE', 4, 'brick.brick_definitions.agent_list.filter.itemName.signed_out', faDonut, 1);

   static readonly ASSISTANCE_ACTIVE = new AgentListFilter(
      'ASSISTANCE_ACTIVE',
      5,
      'brick.brick_definitions.agent_list.filter.itemName.has_assistance_state',
      faHandsHelping,
      2
   );
   static readonly ACTIVE_CALL = new AgentListFilter('ACTIVE_CALL', 6, 'brick.brick_definitions.agent_list.filter.itemName.has_call', faPhone, 3);
   static readonly ONLY_MY_GROUPS = new AgentListFilter('ONLY_MY_GROUPS', 7, 'brick.brick_definitions.agent_list.filter.itemName.my_groups', faUsersCrown, 4);

   private constructor(
      public value: string,
      public filterId: number,
      public translationKey: string,
      public icon: IconDefinition,
      public group: number,
      public cssClass?: string
   ) {
      super();
   }

   public get filterKey(): string {
      return this.filterId.toString();
   }

   public static valueByFilterId(filterId: number): AgentListFilter {
      const typeForKey = _(AgentListFilter.values())
         .filter((x) => x.filterId === filterId)
         .first();
      if (_.isNil(typeForKey)) {
         // return AgentListFilter.CUSTOM;
      }
      return typeForKey;
   }
}
